<span [innerHtml]="htmlMessage"></span>
<div class="mat-simple-snackbar-action">
  <button mat-button class="mat-focus-indicator" (click)="snackBar.dismiss()">X</button>
</div>
